// alterado - revisado

// alterado - revisado

import React, { useState } from 'react'

import { FieldArray } from 'formik'

import {
    buscarEndereco
} from '../../../business-api/LogradouroService'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem3,
    GridItem3xs4,
    GridItem4xs5,
    GridItem6,
    GridItem6sm12xs12,
    GridItem8xs7,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import { 
    TextValidatorText,
    TextValidatorCep,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
    TextFieldTextSelectDestaque,
    TextFieldTextSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import tipoEnderecoList from '../../../business-rules/List/tipoEnderecoList'

import ufList from '../../../business-rules/List/ufList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha,
    ButtonBuscarEndereco,
} from '../../../business-components/Button/Button'

import {
    CircularProgressPadrao,
} from '../../../business-components/CircularProgress/CircularProgress'

import {
    atualizaCepResidencial,
} from './CadastroServiceEndereco'

import {
    incrementaContEndereco,
    processaRegistrosDefaultIniciaisEndereco,
} from './CadastroServiceEndereco'



const CadastroFormEndereco = ({ variaveisGlobais, values, handleChange, handleSubmit, popup }) => {

    const [loadingButtonBuscarEndereco, setLoadingButtonBuscarEndereco] = useState(false)

    const hanbleBuscarEndereco = async ( item ) => {

        setLoadingButtonBuscarEndereco(true)

        await buscarEndereco(variaveisGlobais, item, false)

        setLoadingButtonBuscarEndereco(false)
    }

    const GridEndereco = popup ? GridItem12 : GridItem6sm12xs12
    
    processaRegistrosDefaultIniciaisEndereco(values)

    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <FieldArray name="enderecos">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.enderecos?.map((item, ind) => (
                                <GridEndereco
                                    key={ind}
                                >
                                    <CardGridEntradaDados>
                                        <CardGridDivHeaderEntradaDados>
                                            <GridContainer>
                                                <GridItem4xs5>
                                                    <TextFieldTextSelectDestaque
                                                        name={`enderecos[${ind}].tipoEndereco`}
                                                        placeholder={LABEL.tipoEndereco}
                                                        value={item.tipoEndereco || ''}
                                                        onChange={handleChange}
                                                        list={tipoEnderecoList}
                                                        disabled={item.cepResidencial ? true : false}
                                                    />
                                                </GridItem4xs5>
                                                <GridItem8xs7>
                                                    <IconButtonClearEntradaDados
                                                        onClick={() =>
                                                            arrayHelpers.remove(ind)
                                                        }
                                                        style={{
                                                            display:
                                                                !item.cepResidencial
                                                                    ? "block"
                                                                    : "none"
                                                        }}
                                                    />
                                                </GridItem8xs7>
                                            </GridContainer>
                                        </CardGridDivHeaderEntradaDados>

                                        <CardGridDivBodyEntradaDados>
                                            <GridContainer>
                                                <GridItem3xs4>
                                                    <TextValidatorCep
                                                        name={`enderecos[${ind}].cep`}
                                                        label={LABEL.cep}
                                                        value={item.cep || ''}
                                                        onChange={handleChange}
                                                        onBlur={atualizaCepResidencial(values, item)}
                                                    />
                                                </GridItem3xs4>
                                                <GridItem6>
                                                    <div
                                                        className="relative"
                                                    >
                                                        <ButtonBuscarEndereco
                                                            onClick={() => 
                                                                hanbleBuscarEndereco(item)
                                                            }
                                                            disabled={
                                                                loadingButtonBuscarEndereco || 
                                                                !item.cep ||
                                                                item.cep.length < TAMMAX.cepSemFormatacao
                                                            }
                                                        />
                                                        {loadingButtonBuscarEndereco && (
                                                            <CircularProgressPadrao />
                                                        )}
                                                    </div>
                                                </GridItem6>
                                            </GridContainer>
                                            <GridContainer>
                                                <GridItem12>
                                                    <TextValidatorText
                                                        name={`enderecos[${ind}].endereco`}
                                                        label={LABEL.endereco}
                                                        value={item.endereco || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.endereco}
                                                    />
                                                </GridItem12>
                                            </GridContainer>
                                            <GridContainer>
                                                <GridItem3>
                                                    <TextValidatorText
                                                        name={`enderecos[${ind}].numeroEndereco`}
                                                        label={LABEL.numero}
                                                        value={item.numeroEndereco || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.numeroEndereco}
                                                    />
                                                </GridItem3>
                                                <GridItem3>
                                                    <TextValidatorText
                                                        name={`enderecos[${ind}].complementoEndereco`}
                                                        label={LABEL.complemento}
                                                        value={item.complementoEndereco || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.complementoEndereco}
                                                    />
                                                </GridItem3>
                                                <GridItem6>
                                                    <TextValidatorText
                                                        name={`enderecos[${ind}].bairro`}
                                                        label={LABEL.bairro}
                                                        value={item.bairro || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.bairro}
                                                    />
                                                </GridItem6>
                                            </GridContainer>
                                            
                                            <GridContainer>
                                                <GridItem6>
                                                    <TextValidatorText
                                                        name={`enderecos[${ind}].cidade`}
                                                        label={LABEL.cidade}
                                                        value={item.cidade || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.cidade}
                                                    />
                                                </GridItem6>
                                                {item.tipoEndereco === HARDCODE.idTipoEnderecoResidencial
                                                    ?
                                                        <GridItem6>
                                                            <TextFieldTextSelectRequired
                                                                name={`enderecos[${ind}].uf`}
                                                                label={LABEL.uf}
                                                                value={item.uf || ''}
                                                                onChange={handleChange}
                                                                list={ufList(false)}
                                                                mensagemAlerta={MESSAGE().campoImportanteITCMD}
                                                            />
                                                        </GridItem6>
                                                    : 
                                                        <GridItem6>
                                                            <TextFieldTextSelect
                                                                name={`enderecos[${ind}].uf`}
                                                                label={LABEL.uf}
                                                                value={item.uf || ''}
                                                                onChange={handleChange}
                                                                list={ufList(false)}
                                                            />
                                                        </GridItem6>
                                                }
                                            </GridContainer>
                                        </CardGridDivBodyEntradaDados>
                                    </CardGridEntradaDados>
                                </GridEndereco>
                            ))}
                        </GridContainer>

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirEndereco} 
                            onClick={() =>
                                {
                                    incrementaContEndereco(values)
                                    arrayHelpers.push({
                                        id: values.contEndereco,
                                    })
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </ValidatorFormPadrao>
    )
}

export default CadastroFormEndereco